import {IRange} from "@pg-design/inputs-module";

import {FormRoomType} from "../types/RoomType";

export const getRooms = (roomTypes: FormRoomType[]): IRange<number | ""> => {
    const roomCount = roomTypes.filter((room) => room === FormRoomType.LIVING_ROOM || room === FormRoomType.BEDROOM).length;
    if (!roomCount) {
        return {lower: "", upper: ""};
    }
    if (roomCount === 1) {
        return {lower: "", upper: 1};
    }

    if (roomCount >= 5) {
        return {lower: 5, upper: ""};
    }

    return {lower: roomCount, upper: roomCount};
};
import {IRange} from "@pg-design/inputs-module";

import {FormRoomType} from "../types/RoomType";

export const getRooms = (roomTypes: FormRoomType[]): IRange<number | ""> => {
    const roomCount = roomTypes.filter((room) => room === FormRoomType.LIVING_ROOM || room === FormRoomType.BEDROOM).length;
    if (!roomCount) {
        return {lower: "", upper: ""};
    }
    if (roomCount === 1) {
        return {lower: "", upper: 1};
    }

    if (roomCount >= 5) {
        return {lower: 5, upper: ""};
    }

    return {lower: roomCount, upper: roomCount};
};
